import { AbstractControl, ValidationErrors } from '@angular/forms';

export const getHistoryMinDate = (): Date => {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 89);
    minDate.setHours(0, 0, 0, 0);
    return minDate;
};

export const dateValidator = (control: AbstractControl): ValidationErrors | null => {
    const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
    const isValid = dateRegex.test(control.value);
    return isValid ? null : { invalidDate: { value: control.value } };
};

export const futureDateValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
        return null;
    }
    const now = new Date();
    const isValid = new Date(control.value) < now;

    return isValid ? null : { futureDate: { value: control.value } };
};
export const timeValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || control.value === '') {
        return null;
    }
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    const isValid = timeRegex.test(control.value);
    return isValid ? null : { invalidTime: { value: control.value } };
};

export const checkIfEndDateAfterStartDate = (control: AbstractControl): ValidationErrors | null => {
    const startTime: string = control.get('startTime').invalid ? null : control.get('startTime').value;
    const startDate: string = control.get('startDate').invalid ? null : control.get('startDate').value;

    const endTime: string = control.get('endTime').invalid ? null : control.get('endTime').value;
    const endDate: string = control.get('endDate').invalid ? null : control.get('endDate').value;
    if (!startTime || !endTime
        || startTime === '' || endTime === ''
        || !startDate || !endDate) {
        return null;
    }
    const startDateTime = new Date(startDate + ' ' + startTime);
    const endDateTime = new Date(endDate + ' ' + endTime);

    const isValid = startDateTime < endDateTime;
    return isValid ? null : { invalidTimeOrder: { value: control.value } };
};

export const checkIfEndDateStartDateDiffIsBiggerThanADay = (control: AbstractControl): ValidationErrors | null => {
    const startTime: string = control.get('startTime').invalid ? null : control.get('startTime').value;
    const startDate: string = control.get('startDate').invalid ? null : control.get('startDate').value;

    const endTime: string = control.get('endTime').invalid ? null : control.get('endTime').value;
    const endDate: string = control.get('endDate').invalid ? null : control.get('endDate').value;

    if (!startTime || !endTime
        || startTime === '' || endTime === ''
        || !startDate || !endDate) {
        return null;
    }
    const startDateTime = new Date(startDate + ' ' + startTime);
    const endDateTime = new Date(endDate + ' ' + endTime);

    const diffInHours = Math.abs(endDateTime.getTime() - startDateTime.getTime()) / 3600000;

    const isValid = diffInHours < 24;
    return isValid ? null : { invalidTimeDiff: { value: control.value } };
};

export const checkIfEndTimeAndDateIsBeforeNow = (control: AbstractControl): ValidationErrors | null => {
    const endTime: string = control.get('endTime').invalid ? null : control.get('endTime').value;
    const day: string = control.get('endDate').invalid ? null : control.get('endDate').value;

    if (!endTime || !day || endTime === '' || day === '') {
        return null;
    }

    const endDateTime = new Date(day + ' ' + endTime);
    const now = new Date();

    const isValid = endDateTime < now;
    return isValid ? null : { invalidFutureDateTime: { value: control.value } };
};

export const checkIfObservedDateTimeIsBeforeNow = (control: AbstractControl): ValidationErrors | null => {
    const observedTime: string = control.get('observedTime').invalid ? null : control.get('observedTime').value;
    const observedDate: string = control.get('observedDate').invalid ? null : control.get('observedDate').value;

    if (!observedTime || !observedDate || observedTime === '' || observedDate === '') {
        return null;
    }
    const endDateTime = new Date(observedDate + ' ' + observedTime);
    const now = new Date();
    const isValid = endDateTime < now;
    return isValid ? null : { observedDateTimeError: true };
};

export const checkPublicationStartNotAfterTimeSpanStart = (control: AbstractControl): ValidationErrors | null => {
    const pubStartDate: string      = control.get('trafficDeviationInformation.publicationStartDate')?.value;
    const pubStartTime: string      = control.get('trafficDeviationInformation.publicationStartTime')?.value;
    const timeSpanStartDate: string = control.get('affected.startDate')?.value;
    const timeSpanStartTime: string = control.get('affected.startTime')?.value;

    if (!pubStartDate || !pubStartTime) return null;
    if (!timeSpanStartDate || !timeSpanStartTime) return null;

    const pubStart      = new Date(pubStartDate      + ' ' + pubStartTime);
    const timeSpanStart = new Date(timeSpanStartDate + ' ' + timeSpanStartTime);

    return pubStart <= timeSpanStart ? null : { publicationStartAfterTimeSpanStart: true };
};

export const tooOldDateValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || control.value === '') return null;

    const minDate = getHistoryMinDate();
    return new Date(control.value) >= minDate ? null : { tooOldDate: { value : control.value } };
};
